module.exports = __webpack_public_path__ + "static/img/env10.4a0e02a.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env10.png
// module id = 103
// module chunks = 4